import React from 'react';
import './Tasks.css';

export const ANSWERS = [
  { key: 'yes', icon: '✅', label: 'Yes' },
  { key: 'no', icon: '❌', label: 'No' },
  { key: 'question', icon: '❓', label: 'Question' }
];

export const icon = (key) => (ANSWERS.find(a => a.key === key) || {}).icon || '';

const marker = (format, index) => {
  if (format === 'numbered') return `${index + 1}.`;
  if (format === 'bullets') return '•';
  return '';
};

// One task list. mode "coach": tap an emoji to answer (one change allowed). mode "head": the answers are shown, read only.
const TaskListView = ({ list, mode = 'head', busyKey = '', onAnswer }) => (
  <ul className="tl-items">
    {list.items.map((item, i) => {
      const busy = busyKey === `${list._id}:${item._id}`;
      return (
        <li key={item._id} className="tl-item">
          <div className="tl-line">
            {marker(list.format, i) && <span className="tl-mark">{marker(list.format, i)}</span>}
            <span className="tl-text">{item.text}</span>
            {mode === 'head' && item.response && <span className="tl-answer-big" style={{ marginLeft: 'auto' }}>{icon(item.response)}</span>}
          </div>
          {mode === 'coach' && (
            <>
              <div className="tl-answers">
                {ANSWERS.map(a => (
                  <button
                    key={a.key}
                    type="button"
                    className="tl-btn"
                    aria-pressed={item.response === a.key}
                    aria-label={a.label}
                    disabled={busy || item.locked}
                    onClick={() => onAnswer(list, item, a.key)}
                  >
                    {a.icon}
                  </button>
                ))}
              </div>
              {item.response && (
                <div className="tl-note">{item.locked ? '🔒' : '1 change left'}</div>
              )}
            </>
          )}
        </li>
      );
    })}
  </ul>
);

export default TaskListView;
